import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/i38.png'
import _imports_1 from '../assets/i39.png'
import _imports_2 from '../assets/i40.png'
import _imports_3 from '@/assets/i125.png'
import _imports_4 from '@/assets/i126.png'


const _withScopeId = n => (_pushScopeId("data-v-8c7bc1b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "btnBox" }
const _hoisted_3 = {
  key: 0,
  class: "loginContent"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bg" }, null, -1))
const _hoisted_5 = { class: "box" }
const _hoisted_6 = {
  key: 0,
  class: "fromBox"
}
const _hoisted_7 = { class: "title" }
const _hoisted_8 = { class: "fromBoxT" }
const _hoisted_9 = {
  key: 0,
  class: "inputBox"
}
const _hoisted_10 = { class: "input" }
const _hoisted_11 = { class: "lable2" }
const _hoisted_12 = { class: "input" }
const _hoisted_13 = { class: "lable2" }
const _hoisted_14 = {
  key: 1,
  class: "inputBox"
}
const _hoisted_15 = { class: "input" }
const _hoisted_16 = { class: "input" }
const _hoisted_17 = { class: "forgotBox" }
const _hoisted_18 = {
  key: 0,
  class: "i",
  src: _imports_1,
  alt: ""
}
const _hoisted_19 = {
  key: 1,
  class: "i",
  src: _imports_2,
  alt: ""
}
const _hoisted_20 = { class: "t" }
const _hoisted_21 = {
  key: 2,
  class: "error"
}
const _hoisted_22 = {
  key: 3,
  class: "error",
  style: {"opacity":"0"}
}
const _hoisted_23 = { class: "span" }
const _hoisted_24 = {
  key: 1,
  class: "fromBox fromBox3"
}
const _hoisted_25 = { class: "title" }
const _hoisted_26 = {
  class: "msgTT",
  style: {"width":"31.8rem"}
}
const _hoisted_27 = { class: "fromBoxT" }
const _hoisted_28 = { class: "inputBox" }
const _hoisted_29 = { class: "input" }
const _hoisted_30 = { class: "lable3" }
const _hoisted_31 = { class: "input" }
const _hoisted_32 = { class: "lable3" }
const _hoisted_33 = {
  key: 0,
  class: "yanma"
}
const _hoisted_34 = { class: "input" }
const _hoisted_35 = { class: "lable3" }
const _hoisted_36 = { class: "input" }
const _hoisted_37 = { class: "lable3" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"1rem"} }, null, -1))
const _hoisted_39 = {
  key: 2,
  class: "fromBox2T"
}
const _hoisted_40 = { class: "title" }
const _hoisted_41 = { class: "msgTT" }
const _hoisted_42 = { class: "inputBox" }
const _hoisted_43 = { class: "inputBoxT" }
const _hoisted_44 = { class: "input" }
const _hoisted_45 = { class: "lable" }
const _hoisted_46 = { class: "input" }
const _hoisted_47 = { class: "lable" }
const _hoisted_48 = { class: "input" }
const _hoisted_49 = { class: "lable" }
const _hoisted_50 = { class: "input" }
const _hoisted_51 = { class: "lable" }
const _hoisted_52 = { class: "input" }
const _hoisted_53 = { class: "lable" }
const _hoisted_54 = { class: "newInput" }
const _hoisted_55 = { class: "sBox" }
const _hoisted_56 = { class: "input" }
const _hoisted_57 = { class: "lable" }
const _hoisted_58 = { class: "newInput" }
const _hoisted_59 = { class: "pbox" }
const _hoisted_60 = { class: "yanma2" }
const _hoisted_61 = {
  key: 0,
  class: "inputBoxT"
}
const _hoisted_62 = {
  class: "input",
  style: {"align-items":"flex-start"}
}
const _hoisted_63 = { class: "lable" }
const _hoisted_64 = {
  class: "input",
  style: {"align-items":"flex-start","margin-bottom":".5rem"}
}
const _hoisted_65 = { class: "lable" }
const _hoisted_66 = { class: "uploadRef" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "i",
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_68 = { class: "t" }
const _hoisted_69 = { class: "fileList" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "i",
  src: _imports_4,
  alt: ""
}, null, -1))
const _hoisted_71 = { class: "t" }
const _hoisted_72 = ["onClick"]
const _hoisted_73 = { class: "fileMsg" }
const _hoisted_74 = { class: "PrivacyPolicy" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"1rem"} }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_select_v2 = _resolveComponent("el-select-v2")!
  const _component_el_upload = _resolveComponent("el-upload")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["header", { 'has-bg': _ctx.isBackgroundVisible }]),
    style: _normalizeStyle({position:_ctx.positionFixed?'fixed':'sticky'})
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "logo",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onIndex()))
      }),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: "btn2",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onshowLogin(3)))
        }, _toDisplayString(_ctx.languageData?.H导航Become), 1),
        _createElementVNode("div", {
          class: "btn1",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onshowLogin(1)))
        }, _toDisplayString(_ctx.languageData?.H导航Login), 1)
      ])
    ]),
    (_ctx.showLogin)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", {
            class: _normalizeClass(["contentT", [_ctx.loginIdx == 3?'contentT3':'',_ctx.formData.source == _ctx.languageData?.T02定制Ready按钮?'contentT4':'']])
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("img", {
                class: "close",
                src: _imports_0,
                alt: "",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onshowLogin && _ctx.onshowLogin(...args)))
              }),
              (_ctx.loginIdx == 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.languageData?.Login登录标题), 1),
                    _createElementVNode("div", _hoisted_8, [
                      (_ctx.navIdx == 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            _createElementVNode("div", _hoisted_10, [
                              _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.languageData?.Login登录Email), 1),
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.formData.email,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.email) = $event)),
                                autocomplete: "off"
                              }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_12, [
                              _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.languageData?.Login登录Password), 1),
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.formData.password,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.password) = $event)),
                                type: "password",
                                autocomplete: "new-password"
                              }, null, 8, ["modelValue"])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.navIdx == 2)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                            _createElementVNode("div", _hoisted_15, [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.formData.email,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.email) = $event)),
                                placeholder: "Email",
                                autocomplete: "off"
                              }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_16, [
                              _createVNode(_component_el_input, {
                                class: "codeIpnut",
                                modelValue: _ctx.formData.code,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.code) = $event)),
                                placeholder: "code",
                                autocomplete: "off"
                              }, null, 8, ["modelValue"]),
                              _createElementVNode("div", {
                                class: "yanma",
                                onClick: _cache[8] || (_cache[8] = ($event: any) => (!_ctx.disabledT?_ctx.sendsmsCode(2):''))
                              }, _toDisplayString(_ctx.time), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", {
                          class: "jizhu",
                          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.ondayHas()))
                        }, [
                          (_ctx.dayHas)
                            ? (_openBlock(), _createElementBlock("img", _hoisted_18))
                            : (_openBlock(), _createElementBlock("img", _hoisted_19)),
                          _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.languageData?.Login登录RememberMe), 1)
                        ]),
                        _createElementVNode("div", {
                          class: "wang",
                          onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.loginIdx = 2))
                        }, _toDisplayString(_ctx.languageData?.Login登录ForgottenPassword), 1)
                      ]),
                      _createElementVNode("div", {
                        class: "btnT",
                        onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.navIdx == 1?_ctx.onLogin():_ctx.onLoginCode()))
                      }, _toDisplayString(_ctx.languageData?.Login登录SignIn), 1),
                      (_ctx.errMsg)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_ctx.errMsg), 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_22)),
                      _createElementVNode("div", {
                        class: "msgT",
                        onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.loginIdx = 3))
                      }, [
                        _createTextVNode(_toDisplayString(_ctx.languageData?.Login登录access文本) + " ", 1),
                        _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.languageData?.Login登录access文本2), 1)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.loginIdx == 2)
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.languageData?.J重置密码标题), 1),
                    _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.languageData?.J重置密码描述), 1),
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("div", _hoisted_29, [
                          _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.languageData?.J重置密码Email), 1),
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.formData.email,
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formData.email) = $event)),
                            autocomplete: "off"
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_31, [
                          _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.languageData?.J重置密码VerificationCode), 1),
                          _createVNode(_component_el_input, {
                            class: "codeIpnut",
                            modelValue: _ctx.formData.code,
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formData.code) = $event)),
                            autocomplete: "off"
                          }, null, 8, ["modelValue"]),
                          (_ctx.disabledT)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_33, _toDisplayString(_ctx.time), 1))
                            : (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                class: "yanma",
                                onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.sendsmsCode(3)))
                              }, _toDisplayString(_ctx.time), 1))
                        ]),
                        _createElementVNode("div", _hoisted_34, [
                          _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.languageData?.J重置密码NewPassword), 1),
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.formData.password,
                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.formData.password) = $event)),
                            type: "password",
                            autocomplete: "new-password"
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_36, [
                          _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.languageData?.J重置密码ConfirmPassword), 1),
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.formData.password2,
                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.formData.password2) = $event)),
                            type: "password",
                            autocomplete: "new-password"
                          }, null, 8, ["modelValue"])
                        ])
                      ]),
                      _createElementVNode("div", {
                        class: "btnTT",
                        onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.onResetPwd()))
                      }, _toDisplayString(_ctx.languageData?.J加入Submit), 1),
                      _hoisted_38
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.loginIdx == 3)
                ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                    _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.formData.source), 1),
                    _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.languageData?.Login邀请标题描述), 1),
                    _createElementVNode("div", {
                      class: _normalizeClass(["fromBox fromBox2", _ctx.formData.source == _ctx.languageData?.T02定制Ready按钮?'fromBox4':''])
                    }, [
                      _createElementVNode("div", _hoisted_42, [
                        _createElementVNode("div", _hoisted_43, [
                          _createElementVNode("div", _hoisted_44, [
                            _createElementVNode("div", _hoisted_45, _toDisplayString(_ctx.languageData?.J加入CompanyName), 1),
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.formData.company,
                              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.formData.company) = $event)),
                              autocomplete: "off"
                            }, null, 8, ["modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_46, [
                            _createElementVNode("div", _hoisted_47, _toDisplayString(_ctx.languageData?.J加入FullName), 1),
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.formData.name,
                              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.formData.name) = $event)),
                              autocomplete: "off"
                            }, null, 8, ["modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_48, [
                            _createElementVNode("div", _hoisted_49, _toDisplayString(_ctx.languageData?.J加入JobTitle), 1),
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.formData.position,
                              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.formData.position) = $event)),
                              autocomplete: "off"
                            }, null, 8, ["modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_50, [
                            _createElementVNode("div", _hoisted_51, _toDisplayString(_ctx.languageData?.J加入CompanyEmail), 1),
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.formData.email,
                              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.formData.email) = $event)),
                              autocomplete: "off"
                            }, null, 8, ["modelValue"])
                          ]),
                          _createElementVNode("div", _hoisted_52, [
                            _createElementVNode("div", _hoisted_53, _toDisplayString(_ctx.languageData?.J加入SelectCountry), 1),
                            _createElementVNode("div", _hoisted_54, [
                              _createElementVNode("div", _hoisted_55, [
                                _createVNode(_component_el_select_v2, {
                                  "popper-class": "type-popper",
                                  modelValue: _ctx.formData.country,
                                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.formData.country) = $event)),
                                  options: _ctx.countryList,
                                  "value-key": "en",
                                  "popper-append-to-body": false,
                                  props: {
														label: 'en',
														value: 'en',
													},
                                  placeholder: ""
                                }, null, 8, ["modelValue", "options"])
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_56, [
                            _createElementVNode("div", _hoisted_57, _toDisplayString(_ctx.languageData?.J加入PhoneNumber), 1),
                            _createElementVNode("div", _hoisted_58, [
                              _createElementVNode("div", _hoisted_59, [
                                _createElementVNode("div", _hoisted_60, _toDisplayString(_ctx.countryList.find((item) => item.en == _ctx.formData.country)?.prefix), 1),
                                _createVNode(_component_el_input, {
                                  class: "codeIpnut2",
                                  modelValue: _ctx.formData.phone,
                                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.formData.phone) = $event)),
                                  autocomplete: "off"
                                }, null, 8, ["modelValue"])
                              ])
                            ])
                          ])
                        ]),
                        (_ctx.formData.source == _ctx.languageData?.T02定制Ready按钮)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                              _createElementVNode("div", _hoisted_62, [
                                _createElementVNode("div", _hoisted_63, _toDisplayString(_ctx.languageData?.J加入Message), 1),
                                _createVNode(_component_el_input, {
                                  class: "textareaT",
                                  type: "textarea",
                                  modelValue: _ctx.formData.message,
                                  "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.formData.message) = $event)),
                                  autocomplete: "off"
                                }, null, 8, ["modelValue"])
                              ]),
                              _createElementVNode("div", _hoisted_64, [
                                _createElementVNode("div", _hoisted_65, _toDisplayString(_ctx.languageData?.J加入Attachments), 1),
                                _createVNode(_component_el_upload, {
                                  ref: "uploadRef",
                                  "file-list": _ctx.fileList,
                                  "onUpdate:fileList": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.fileList) = $event)),
                                  "show-file-list": false,
                                  action: "/api/Ajax/upload",
                                  "on-change": _ctx.onChange,
                                  class: "upload-demo",
                                  "auto-upload": true
                                }, {
                                  trigger: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_66, [
                                      _hoisted_67,
                                      _createElementVNode("div", _hoisted_68, _toDisplayString(_ctx.languageData?.J加入SelectFile), 1)
                                    ])
                                  ]),
                                  _: 1
                                }, 8, ["file-list", "on-change"]),
                                _createElementVNode("div", _hoisted_69, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fileList, (item, index) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      class: "list",
                                      key: index
                                    }, [
                                      _hoisted_70,
                                      _createElementVNode("div", _hoisted_71, _toDisplayString(item.name), 1),
                                      _createElementVNode("img", {
                                        class: "d",
                                        src: _imports_0,
                                        alt: "",
                                        onClick: _withModifiers(($event: any) => (_ctx.delFile(index)), ["stop"])
                                      }, null, 8, _hoisted_72)
                                    ]))
                                  }), 128))
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_73, _toDisplayString(_ctx.languageData?.J文件上传提示), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_74, [
                        _createTextVNode(_toDisplayString(_ctx.languageData?.J加入Msg), 1),
                        _createElementVNode("span", {
                          onClick: _cache[27] || (_cache[27] = 
//@ts-ignore
(...args) => (_ctx.onPrivacyPolicy && _ctx.onPrivacyPolicy(...args)))
                        }, _toDisplayString(_ctx.languageData?.J加入PrivacyPolicy), 1)
                      ]),
                      _createElementVNode("div", {
                        class: "btnTT",
                        onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.onContact()))
                      }, _toDisplayString(_ctx.languageData?.J加入Submit), 1),
                      _hoisted_75
                    ], 2)
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 2)
        ]))
      : _createCommentVNode("", true)
  ], 6))
}